<template>
  <div 
    class="error-container"
    role="alert"
    aria-live="polite"
  >
    <v-card 
      class="error-card"
      :aria-labelledby="title ? 'error-title' : undefined"
    >
      <div class="error-content">
        <h2 v-if="title" id="error-title" class="error-title">{{ title }}</h2>
        <p class="error-message">{{ message }}</p>
        <v-btn
          v-if="showRetry"
          color="#008153"
          class="retry-button"
          @click="$emit('retry')"
        >
          Try Again
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  title: {
    type: String,
    default: "Oops! Something Went Wrong",
  },
  message: {
    type: String,
    default: "We encountered an unexpected error. Please try again.",
  },
  showRetry: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["retry"]);
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 2rem;
}

.error-card {
  max-width: 600px;
  width: 100%;
  padding: 2rem;
  text-align: center;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.error-icon {
  width: 120px;
  height: 120px;
  margin-bottom: 1rem;
}

.error-title {
  color: var(--primary-blue);
  font-size: var(--fs-xxl);
  font-weight: 600;
  margin: 0;
}

.error-message {
  color: #666666;
  font-size: 18px;
  line-height: 1.5;
  margin: 0;
  max-width: 480px;
  white-space: pre-line;
}

.retry-button {
  min-width: 160px;
  height: 48px;
  font-size: var(--fs-medium);
  font-weight: 600;
  text-transform: none;
  border-radius: 12px;
  color: white;
}

.retry-button:hover {
  background-color: #00734a !important;
}
</style>
